import axios from "axios";
import { isFavHandlerReady } from "../store/favourites/isFavHandlerReady";
import { favouriteList } from "../store/favourites/favouriteList";

export const addFavouritesApi = (id: number): any => {
  axios
    .get(`/ajax/student/favourites/add/${id}/`, {
      withCredentials: true,
    })
    .then(res => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      isFavHandlerReady.update(_ => true);
      // add new favLocation to favList
      favouriteList.update(data => {
        return [...data, res.data.id];
      });
    })
    .catch(error => {
      console.log(error);
    })
    .then(() => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      isFavHandlerReady.update(_ => true);
    });
};
